/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { AppDispatch } from '../../store'; // Redux hooks
import { createProject } from '../../store/feature/projectSlice'; // Redux actions
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2'; // SweetAlert2 kütüphanesi

const AddProject: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const token = localStorage.getItem('token') || ''; // Token localStorage'den alınır

  // Proje ekleme işlemi
  const handleCreate = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);

    if (!token) {
      Swal.fire('Unauthorized', 'Proje Eklenirken bir sorun oluştu!', 'error');
      return;
    }

    try {
      formData.append('token', token); // Token'i formData'ya ekle

      const result = await dispatch(createProject(formData)).unwrap();
      Swal.fire('Başarılı', 'Proje Başarıyla Eklendi', 'success');

      if (event.currentTarget) {
        event.currentTarget.reset(); // Formu sıfırla
      }
    } catch (err) {
      Swal.fire('Hata', 'Proje eklenirken bir hata oluştu.', 'error');
      console.error('Proje ekleme hatası:', err);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-center mb-6">Yeni Proje Ekle</h1>

      {/* Proje Ekleme Formu */}
      <form className="bg-white p-6 shadow-md rounded-lg max-w-md mx-auto space-y-4" onSubmit={handleCreate}>
        <input
          type="text"
          name="title"
          placeholder="Başlık"
          required
          className="w-full p-2 border border-gray-300 rounded-md"
        />
        <textarea
          name="content"
          placeholder="İçerik"
          required
          className="w-full p-2 border border-gray-300 rounded-md"
        ></textarea>
        <input
          type="file"
          name="photo"
          accept="image/*"
          required
          className="w-full p-2 border border-gray-300 rounded-md"
        />
        <button
          type="submit"
          className="w-full bg-green-500 text-white py-2 rounded-md hover:bg-green-600 transition duration-300"
        >
          EKLE
        </button>
      </form>
    </div>
  );
};

export default AddProject;
